import { render } from "./EntregasHorariosView.vue?vue&type=template&id=8e23cb66&scoped=true"
import script from "./EntregasHorariosView.vue?vue&type=script&lang=js"
export * from "./EntregasHorariosView.vue?vue&type=script&lang=js"

import "./EntregasHorariosView.vue?vue&type=style&index=0&id=8e23cb66&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e23cb66"]])

export default __exports__